import { type FC, type IframeHTMLAttributes } from 'react'

import { ImageGalleryYoutubeSlideStyled } from '@/components/shared/image-gallery-modal/styled'

type ImageGalleryYoutubeSlideProps = IframeHTMLAttributes<HTMLIFrameElement> & {
  /**
   * Whether the image of the slide is in view or not
   */
  inView: boolean
}

export const ImageGalleryYoutubeSlide: FC<ImageGalleryYoutubeSlideProps> = ({
  inView,
  title,
  ...iframeProps
}) => {
  /**
   * It should return an empty div with the correct dimensions so the slides work properly
   * AND the video stop playing when it is not "inView"
   */
  if (!inView) {
    return <ImageGalleryYoutubeSlideStyled />
  }

  return (
    <ImageGalleryYoutubeSlideStyled>
      <iframe title={title} {...iframeProps} />
    </ImageGalleryYoutubeSlideStyled>
  )
}
